import { Component, Input, OnInit } from "@angular/core";
import { CommonModule } from '@angular/common';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { BackendApiService } from "../../../../../app/services/backend-api.service";
import { BaseUrlConstantsService } from "../../../../../app/services/base-url-constants.service";
import { SpectraChartComponent } from "../../spectra-chart/spectra-chart.component";
@Component({
  selector: 'app-cepstrum-spectra',
  standalone: true,
  imports: [CommonModule, NgbNavModule, SpectraChartComponent],
  templateUrl: './cepstrum-spectra.component.html',
  styleUrl: './cepstrum-spectra.component.scss'
})
export class CepstrumSpectraComponent implements OnInit {
  @Input() data: any;
  public clientId: string | null = null;
  public loadingCepstrumSpectra = false;
  public cepstrumData: any = null;
  public canvasDataSeries: any[] = [];

  public loadingCrestFactor = false;
  public crestFactorData: any = null;

  // -- TABLE 2: PREDOMINANT FREQUENCY --
  public loadingPredominantFrequency = false;
  public predominantFrequencyData: any[] = [];
  public FFTId = sessionStorage.getItem('FFTId');
  public KurtosisId = sessionStorage.getItem('KurtosisId')
  constructor(private service: BackendApiService) {
    this.clientId = localStorage.getItem('user_id');
  }

  ngOnInit(): void {
    this.fetchCepstrumSpectra();
    this.fetchCrestFactor();
    // this.fetchPredominantFrequency();
  }

  async fetchCepstrumSpectra() {
    try {
      this.loadingCepstrumSpectra = true;
      this.loadingPredominantFrequency = true;
      const apiUrl = `${BaseUrlConstantsService.PIEZO_DIAGNOSTICS_GEARBOX_CEPSTRUM_API}${this.FFTId}/${this.data.assetId}`;
      const response: any = await this.service.getDataV2(apiUrl);

      if (response?.status === "success") {
        this.cepstrumData = response.body.result;
        this.canvasDataSeries = this.mapToCanvasSeries(this.cepstrumData);
        this.predominantFrequencyData = response.body.result.predominantData;
      }
    } catch (error) {
      console.error("Error loading velocity amplitude spectra", error);
    } finally {
      this.loadingCepstrumSpectra = false;
      this.loadingPredominantFrequency = false;
    }
  }

  // --- 3. CREST FACTOR ---
  async fetchCrestFactor() {
    try {
      this.loadingCrestFactor = true;
      const apiUrl = `${BaseUrlConstantsService.PIEZO_DIAGNOSTICS_FFT_CREST_FACTOR_API}${this.FFTId}`;
      const response: any = await this.service.getDataV2(apiUrl);

      if (response?.status === "success" || response?.data?.status === "success") {
        const body = response.body || response.data?.body;
        this.crestFactorData = body?.result;
      }
    } catch (error) {
      console.error("Error loading crest factor", error);
    } finally {
      this.loadingCrestFactor = false;
    }
  }

  // --- 4. PREDOMINANT FREQUENCY ---
  // async fetchPredominantFrequency() {
  //   try {
  //     this.loadingPredominantFrequency = true;
  //     const apiUrl = `${BaseUrlConstantsService.DIAGNOSTICS_FFT_PREDOMINANT_API}16,17,18/2824752?type=fft&userId=2&assetType=MOTOR`;

  //     const response: any = await this.service.getDataV2(apiUrl);
  //     console.log("Predominant Frequency Response: ", response);

  //     if (response?.data?.status === "success") {
  //       this.predominantFrequencyData = response.data.body || [];
  //     }
  //   } catch (error) {
  //     console.error("Error loading predominant frequency", error);
  //   } finally {
  //     this.loadingPredominantFrequency = false;
  //   }
  // }

  private mapToCanvasSeries(apiBody: any): any[] {
    if (!apiBody) return [];
    const { chartXAxisData, chartYAxisData, chartZAxisData, xLabel, yLabel, zLabel } = apiBody;

    return [
      {
        type: "line",
        name: xLabel || 'Axial',
        showInLegend: true,
        color: '#1e88e5',
        lineThickness: 2,
        markerSize: 0,
        xValueType: "number",
        dataPoints: chartXAxisData?.map((p: any) => ({ x: p.x, y: p.y })) || []
      },
      {
        type: "line",
        name: yLabel || 'Tangential (Vertical)',
        showInLegend: true,
        color: '#43a047',
        lineThickness: 2,
        markerSize: 0,
        xValueType: "number",
        dataPoints: chartYAxisData?.map((p: any) => ({ x: p.x, y: p.y })) || []
      },
      {
        type: "line",
        name: zLabel || 'Radial (Horizontal)',
        showInLegend: true,
        color: '#fb8c00',
        lineThickness: 2,
        markerSize: 0,
        xValueType: "number",
        dataPoints: chartZAxisData?.map((p: any) => ({ x: p.x, y: p.y })) || []
      }
    ];
  }
}
